import React from "react";

/**
 * Pill toggle for KPI date scope.
 * - value: "today" | "week" | "current_month" (or legacy "month") | "last_month" | "ytd"
 * - onChange: (next) => void
 * - showToday: when true, prepends the "Today" pill (opt-in per page).
 */
const OPTIONS = [
  { v: "today",         label: "Today",         title: "Today only" },
  { v: "week",          label: "Week",          title: "Current calendar week (Mon → today)" },
  { v: "current_month", label: "Current Month", title: "Current calendar month (1st → today)" },
  { v: "last_month",    label: "Last Month",    title: "Full previous calendar month" },
  { v: "ytd",           label: "YTD",           title: "Year-to-date (Jan 1 → today)" },
];

export default function StatsScopeToggle({ value, onChange, showToday = false }) {
  const options = showToday ? OPTIONS : OPTIONS.filter((o) => o.v !== "today");
  // Legacy callers still pass "month" — treat it as current_month for
  // highlight purposes without forcing every parent to migrate today.
  const normalized = value === "month" ? "current_month" : value;
  return (
    <div
      className="inline-flex rounded-full bg-secondary/60 p-1"
      data-testid="stats-scope-toggle"
      role="radiogroup"
      aria-label="Stats time scope"
    >
      {options.map((opt) => {
        const active = normalized === opt.v;
        return (
          <button
            key={opt.v}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.v)}
            title={opt.title}
            className={`px-3 h-7 text-[11px] font-medium uppercase tracking-wider rounded-full transition-colors ${
              active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`stats-scope-${opt.v}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
